export const paths = {
  root: '/',
  blog: '/blog',
  /** In-app news page. NewsAPI.org URL: `appConfig.externalApis.news.everything`. */
  news: '/news',
  investments: '/investments',
  invest: '/invest',
  claim: '/claim',
  portfolio: {
    main: '/portfolio',
    genesisNfts: {
      main: '/portfolio/genesis-nfts',
      genesisNft: {
        main: '/portfolio/genesis-nfts/:series',
        tokens: {
          main: '/portfolio/genesis-nfts/:series/tokens',
          token: {
            main: '/portfolio/genesis-nfts/:series/tokens/:tokenId',
            claimWlth: '/portfolio/genesis-nfts/:series/tokens/:tokenId/claim-wlth',
            claimProfit: '/portfolio/genesis-nfts/:series/tokens/:tokenId/claim-profit',
            accelerateVesting:
              '/portfolio/genesis-nfts/:series/tokens/:tokenId/accelerate-vesting',
          },
        },
      },
      rewards: {
        claim: '/portfolio/genesis-nfts/claim-rewards',
      },
      vestedTokens: {
        claim: '/portfolio/genesis-nfts/vested-tokens/claim',
      },
    },
    investments: {
      claimProfitAll: '/portfolio/investments/claim-profit',
      claimFundProfit: '/portfolio/investments/:fundId/claim-profit',
    },
    publicStaking: {
      unstake: '/portfolio/public-staking/unstake',
      claimRewards: '/portfolio/public-staking/claim-rewards',
    },

    strategicPartners: {
      claim: '/portfolio/strategic-partners/claim-wlth',
      accelerateVesting: '/portfolio/strategic-partners/accelerate-vesting',
    },
    marketing: {
      claim: '/portfolio/marketing/claim-wlth',
    },
    advisors: {
      claim: '/portfolio/advisors/claim-wlth',
    },
    strategicPartners1: {
      claim: '/portfolio/strategic-partners-1/claim-wlth',
      accelerateVesting: '/portfolio/strategic-partners-1/accelerate-vesting',
    },
    team: {
      claim: '/portfolio/team/claim-wlth',
    },
  },
  strategies: {
    main: '/strategies',
    investment: '/strategies/:id/investment',
  },
  funds: {
    main: '/funds',
    exclusiveAccess: {
      main: '/exclusive-access',
      companies: '/companies',
      preIPOAccessDetails: '/companies/:fundId',
      preIPOAccessInvestment: '/companies/:fundId/invest',
      fundsOverview: '/funds-overview',
    },
    referralDashboard: '/referral-dashboard',
    fund: {
      main: '/funds/:fundId',
      investment: '/funds/:id/investment',
      staking: {
        main: '/funds/:fundId/staking',
      },
      projects: {
        main: '/funds/:fundId/projects',
        project: {
          main: '/funds/:fundId/projects/:projectId',
          events: '/funds/:fundId/projects/:projectId/events',
        },
      },
      tokens: {
        main: '/funds/:fundId/tokens',
        token: {
          main: '/funds/:fundId/tokens/:tokenId',
          split: '/funds/:fundId/tokens/:tokenId/split',
        },
      },
    },
    communityFund: {
      main: `/funds/${process.env.NEXT_PUBLIC_COMMUNITY_FUND_URL_ID}`,
      allStakersLeaderboard: `/funds/${process.env.NEXT_PUBLIC_COMMUNITY_FUND_URL_ID}/all-stakers-leaderboard`,
      top50StakersLeaderboard: `/funds/${process.env.NEXT_PUBLIC_COMMUNITY_FUND_URL_ID}/top50-stakers-leaderboard`,
      claimProceeds: `/funds/${process.env.NEXT_PUBLIC_COMMUNITY_FUND_URL_ID}/claim-proceeds`,
    },
  },
  earn: {
    main: '/earn',
    campaigns: {
      main: '/earn/campaigns/:campaignId',
    },
    projects: '/earn/projects',
    project: {
      main: '/earn/projects/:projectId',
      mission: {
        main: '/earn/projects/:projectId/quests/:questId/missions/:missionId',
      },
    },
    leaderboard: '/earn/leaderboard/:campaignId',
  },
  // Legacy rewards.* keys resolve to /earn (next.config redirects /rewards -> /earn)
  rewards: {
    main: '/earn',
    projects: '/earn/projects',
    project: {
      main: '/earn/projects/:projectId',
      mission: {
        main: '/earn/projects/:projectId/quests/:questId/missions/:missionId',
      },
    },
    leaderboard: '/earn/leaderboard/:campaignId',
  },
  marketplace: {
    main: '/marketplace',
    collection: '/marketplace/collection/:contractAddress',
    nftPage: '/marketplace/nft/:contractAddress/:nftId',
    buyNft: '/marketplace/nft/:contractAddress/:nftId/:listingId/buy',
    sellNft: '/marketplace/nft/:contractAddress/:nftId/sell',
    orders: '/marketplace/orders',
  },
  stakingForParticipation: {
    main: '/smart-staking',
  },
  withdrawal: '/withdrawal/:address',
  equity: '/equity',
  community: {
    main: '/community',
    communityHome: '/community/home',
    forum: '/community/forum',
    governance: '/community/governance',
    leaderboard: '/community/leaderboard',
  },
  learn: '/learn',
  gift: '/gift',
  account: {
    main: '/account',
    wallets: '/account',
  },
  auth: {
    main: '/auth',
    register: {
      main: '/auth/register',
      verification: '/auth/register/verification',
      torusVerification: '/auth/register/torus-verification',
    },
    login: {
      sso: '/sso',
      main: '/auth/login',
      email: '/auth/login/email',
      emailVerification: '/auth/login/email/verification',
      verification: '/auth/login/verification',
      torus: '/auth/login/torus',
    },
    emailConfirmation: {
      main: '/auth/email-confirmation',
      verification: '/auth/email-confirmation/verification',
    },
    changeEmailConfirmation: {
      main: '/auth/change-email-confirmation',
      verification: '/auth/change-email-confirmation/verification',
    },
  },
  connectWallet: '/connect-wallet',
  connectEmail: '/connect-email',
  connectWeb3auth: '/connect-web3auth',
  importWalletTutorial: '/how-to-import-wallet',
  support: '/support',
  security: '/security',
  treasury: '/treasury',
  referral: '/referral',
  tokenizedAssets: '/tokenized-assets',
  notFound: '*',
  fairsideReferral: 'https://fairside.io/?referralCode=ZQT3MBufOpFIJZHzi6dU1A7c6',
  androidStoreUrl: 'https://play.google.com/store/apps/details?id=xyz.wlth.app',
  /** AU storefront — US/UK geo-restricted; bare /app/ URL 404s in those regions. */
  iosStoreUrl: 'https://apps.apple.com/au/app/wlth/id6752845168',
}
